const state = {
    groupId: -1,
    localSettings: { floatPlace: [] },
    /**浮球位置 */
    floatPlace: [],
    /**打开云手机是否全屏 */
    fullScreen: [],
    /**云手机默认清晰度 */
    initOdefinition: [],
    // 续费数组
    renewList: [],
    channelCode: 'xunliu',
    tipsShow: true,
    /**视图模式：1 单视图，9 九宫格，16 十六宫格（持久化）*/
    gonggeshow: 9
}
const mutations = {
    SET_GROUPID: (state, type) => {
        state.groupId = type
    },
    SET_LOCALSETTINGS: (state, type, parameters) => {
        state.localSettings[type] = parameters
    },
    SET_FLOATPLACE: (state, parameters) => {
        state.floatPlace = parameters
    },
    SET_FULLSCREEN: (state, parameters) => {
        state.fullScreen = parameters
    },
    SET_INITODEFINITION: (state, parameters) => {
        state.initOdefinition = parameters
    },
    SET_RENEWLIST: (state, cover) => {
        state.renewList = cover
    },
    SET_CHANNELCODE: (state, cover) => {
        state.channelCode = cover
    },
    SET_TIPSSHOW: (state, cover) => {
        state.tipsShow = cover
    },
    SET_GONGGESHOW: (state, cover) => {
        state.gonggeshow = cover
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}